<div style="overflow-y: hidden; height: 100vh">


  <header class="mobile objects">
    <div>
      <mat-icon svgIcon="ss-logo" class="logo-img" *ngIf="prevToggleValue.length == 1"></mat-icon>
      <mat-icon (click)="back()" *ngIf="prevToggleValue.length > 1">arrow_left</mat-icon>
    </div>
    <div style="color: white">{{ headerTitle }}</div>
    <div class=" burger-menu">
      <button ejs-speeddial id="speedDialMenu" class="mat-basic" openIconCss="e-icons e-menu" closeIconCss="e-icons e-close" position="TopRight" (created)="speedMenuCreated()" (clicked)="speedMenuClicked($event)" [items]="menuItems"></button>
    </div>
  </header>

  <ng-container *ngIf="toggle === 'suchen'">
    <main class="mobile objects search">

      <mat-toolbar class="search-block">
        <mat-toolbar-row>

          <div style="display: flex; width: 100%;">
            <mat-icon>search</mat-icon>
            <input class="search-control" [(ngModel)]="searchField" (keyup)="applyFilter(searchField)" type="text" placeholder="Objekt suchen..." #input />
            <mat-icon (click)="clearInput()">close</mat-icon>
          </div>
        </mat-toolbar-row>
      </mat-toolbar>

      <mat-list role="list" style="padding: 0;">
        <ng-container *ngFor="let objekt of filteredDescriptions">
          <mat-list-item role="listitem" class="list-item" (click)="highlight(objekt)" [ngClass]="{ highlight: selectedAdressID == objekt.objectID }">
            <div class="contentWrapper">
              <div>
                {{ objekt.beschreibung }}
              </div>
              <div>
                <button class="search-icon" mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_horiz</mat-icon>
                </button>
              </div>
            </div>
          </mat-list-item>
          <mat-divider></mat-divider>
        </ng-container>
      </mat-list>

      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="toggleBtn('objektansicht')"> {{ "MAIN_APP_OBJECTS.objektansicht" | translate }} </button>
        <button mat-menu-item (click)="neueNotiz()"> {{ "MAIN_APP_OBJECTS.notizen" | translate }} </button>
        <button mat-menu-item (click)="toggleBtn('objekt-aktivitat')"> {{ "MAIN_APP_OBJECTS.aktivitäten" | translate }} </button>
        <button mat-menu-item (click)="toggleBtn('teilen')"> {{ "MAIN_APP_OBJECTS.teilen" | translate }} </button>
        <button mat-menu-item (click)="toggleBtn('adressen')"> {{ "MAIN_APP_OBJECTS.adressen" | translate }} </button>
        <button [disabled]="!rechtObjektLoeschen || !currObjektID" mat-menu-item (click)="onDelObjekt()"> {{ "MAIN_APP_OBJECTS.objektLöschen" | translate }} </button>
      </mat-menu>
    </main>
  </ng-container>

  <ng-container *ngIf="toggle === 'baum'">
    <main class="mobile objects treeview">
      <div>
        <mat-toolbar class="search-block">
          <mat-toolbar-row>
            <div style="display: flex; width: 100%;">
              <mat-icon>search</mat-icon>
              <input class="search-control" type="text" placeholder="Objekt suchen..." aria-label="Suche" matInput [formControl]="myControl" [matAutocomplete]="auto" />
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="getObjektDesc" (optionSelected)="selectedSearchItem($event)">
                <cdk-virtual-scroll-viewport class="autocomplete-test-viewport" [ngStyle]="{ height: height }" itemSize="15">
                  <mat-option *ngFor="let objekt of filteredDescriptions" [value]="objekt.objectID"> {{ objekt.beschreibung }} </mat-option>
                </cdk-virtual-scroll-viewport>
              </mat-autocomplete>
              <mat-icon (click)="clearInput()">close</mat-icon>
            </div>
          </mat-toolbar-row>
        </mat-toolbar>
      </div>

      <ng-container *ngIf="showObjektBaum">
        <div style="overflow-y: auto;">
	        <ejs-treeview #treeObjekte (click)="nodeclicked()" (nodeExpanded)="nodesExpanded($event)" [cssClass]="cssClass" [fields]="field" id="treeelement"></ejs-treeview>
        </div>
      </ng-container>
      <ng-container *ngIf="!showObjektBaum">
        <ejs-listview #objListView [dataSource]="dataSourceObjListView" [fields]="fieldsObjView" (select)="listViewItemclicked($event)">
          <ng-template #template let-dataSource="">
            <div class="e-list-wrapper e-list-multi-line e-list-avatar">
              <img src="{{ dataSource.objectTypeImg }}" style="background: #bcbcbc" />
              <span class="e-list-item-header">{{dataSource.objectNumber}}</span>
              <span class="e-list-content">{{ dataSource.description }}<br />{{ dataSource.note4 }}</span>
            </div>
          </ng-template>
        </ejs-listview>
      </ng-container>
    </main>
  </ng-container>

  <ng-container *ngIf="toggle === 'mutieren'">
    <main class="mobile objects mutation" id="ngObjektForm" [formGroup]="formGrp" #objektForm>
      <mat-accordion [multi]="false">
        <mat-expansion-panel [disabled]="!objectDataLoaded" [expanded]="true">
          <mat-expansion-panel-header [collapsedHeight]="expandPanelHeaderCollapsedHeight" [expandedHeight]="expandPanelHeaderExpandendHeight">
            <mat-panel-title> {{ "MAIN_APP_OBJECTS.OBJEKTDETAILS" | translate }} {{ getOfflineState() }} </mat-panel-title>
            <mat-panel-description> </mat-panel-description>
          </mat-expansion-panel-header>
          <mat-tab-group dynamicHeight (selectedTabChange)="objDetailsTabChange($event)">
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon>data_object</mat-icon>
              </ng-template>

              <div class="tabContentWrapper" [ngClass]="{'small': checkInnerWidth() }">
                <mat-card appearance="outlined" style="display: block; flex: 1;">
                  <span *ngFor="let swissField of mySwissFieldsObjectDetailLinks" class="form-row">
                    <app-swiss-dynamic-form [swissField]="swissField"></app-swiss-dynamic-form>
                  </span>
                </mat-card>
                <mat-card appearance="outlined" style="display: block; flex: 1;">
                  <span *ngFor="let swissField of mySwissFieldsObjectDetailRechts" class="form-row">
                    <app-swiss-dynamic-form [swissField]="swissField"></app-swiss-dynamic-form>
                  </span>
                </mat-card>
              </div>
              <ng-container *ngIf="false">
                <div style="display: flex">
                  <mat-card appearance="outlined" style="flex: 1 1 50%" class="mat-elevation-z4">
                    <span *ngFor="let swissField of mySwissFieldsObjectDetailLinks" class="form-row">
                      <app-swiss-dynamic-form [swissField]="swissField"></app-swiss-dynamic-form>
                    </span>
                  </mat-card>
                  <mat-card appearance="outlined" style="flex: 1 1 50%" class="mat-elevation-z4">
                    <span *ngFor="let swissField of mySwissFieldsObjectDetailRechts" class="form-row">
                      <app-swiss-dynamic-form [swissField]="swissField"></app-swiss-dynamic-form>
                    </span>
                  </mat-card>
                </div>
              </ng-container>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon>precision_manufacturing</mat-icon>
              </ng-template>
              <ejs-richtexteditor #richTxtEditor1 [toolbarSettings]="tools" [height]="height" formControlName="manuDesc" (actionBegin)="rteActionBegin($event)" (change)="rteContentChange($event, 'manuDesc')" [value]="currObjekt.manufacturingDescription">
              </ejs-richtexteditor>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon>note</mat-icon>
              </ng-template>
              <ejs-richtexteditor #richTxtEditor2 [toolbarSettings]="tools" [height]="height" formControlName="memo" (actionBegin)="rteActionBegin($event)" (change)="rteContentChange($event, 'memo')" [value]="currObjekt.memo">
              </ejs-richtexteditor>
            </mat-tab>
          </mat-tab-group>
        </mat-expansion-panel>
        <mat-expansion-panel [disabled]="!objectDataLoaded">
          <mat-expansion-panel-header [collapsedHeight]="expandPanelHeaderCollapsedHeight" [expandedHeight]="expandPanelHeaderExpandendHeight">
            <mat-panel-title> {{ "MAIN_APP_OBJECTS.OBJEKTERWEITERUNG" | translate }} </mat-panel-title>
            <mat-panel-description> </mat-panel-description>
          </mat-expansion-panel-header>
          <div style="gap: 5px">
            <span *ngFor="let swissField of mySwissFieldsObjectExtensionLinks" class="form-row">
              <app-swiss-dynamic-form [swissField]="swissField"></app-swiss-dynamic-form>
            </span>
            <span *ngFor="let swissField of mySwissFieldsObjectExtensionRechts" class="form-row">
              <app-swiss-dynamic-form [swissField]="swissField"></app-swiss-dynamic-form>
            </span>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </main>
  </ng-container>

  <ng-container *ngIf="toggle === 'adressen'">
    <main class="mobile objects addresses">
      <table mat-table [dataSource]="dataSourceObjektAdressen">
        <!-- Name Column -->
        <ng-container matColumnDef="kombiname">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_OBJECTS.name" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.fullName }}
          </td>
        </ng-container>

        <!-- Strasse Column -->
        <ng-container matColumnDef="street">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_OBJECTS.strasse" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.street1 }}
          </td>
        </ng-container>

        <!-- Plz Column -->
        <ng-container matColumnDef="plz/ort">
          <th mat-header-cell *matHeaderCellDef> {{ "MAIN_APP_OBJECTS.plz" | translate }}/{{ "MAIN_APP_OBJECTS.ort" | translate }} </th>
          <td mat-cell *matCellDef="let element"> {{ element.zip }} {{ element.city }} </td>
        </ng-container>

        <!-- Settings Menu Column -->
        <ng-container matColumnDef="menuOA">
          <th mat-header-cell *matHeaderCellDef style="text-align: center"></th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            <button mat-icon-button [matMenuTriggerFor]="anpaMenu" aria-label="Example icon-button with a menu">
              <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #anpaMenu="matMenu">
              <button mat-menu-item (click)="delContactPersonLink(element)">
                <mat-icon>delete_forever</mat-icon>
                <span>{{ "MAIN_APP_OBJECTS.adressverknüpfungLöschen" | translate }}</span>
              </button>
              <button mat-menu-item (click)="changeContactPerson(element)">
                <mat-icon>person_search</mat-icon>
                <span>{{ "MAIN_APP_OBJECTS.adressPartnermutation" | translate }}</span>
              </button>
              <button mat-menu-item (click)="copyAddressesOnSubObjects(element)">
                <mat-icon>edit_note</mat-icon>
                <span>{{ "MAIN_APP_OBJECTS.adresseAufUnterobjekteUbernehmen" | translate }}</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedObjAdrColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedObjAdrColumns" [ngClass]="{
            highlight: selectedObjektAdressID == row.adressID
          }"></tr>
      </table>
    </main>
  </ng-container>

  <ng-container *ngIf="toggle === 'objekt-aktivitat'">
    <main class="mobile objects activities">
      <table mat-table [dataSource]="dataSourceObjektAktivitaeten">
        <!-- Art Column -->
        <ng-container matColumnDef="doku_art">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_OBJECTS.art" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
	          <img src="/assets/obj_activity_icons/{{ element.imageFile }}"/>
          </td>
        </ng-container>

        <!-- Datum Column -->
        <ng-container matColumnDef="doku_bearbeitet">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_OBJECTS.datum" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ formatDate(element.datum) }}
          </td>
        </ng-container>

        <!-- Beschreibung Column -->
        <ng-container matColumnDef="doku_desc">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_OBJECTS.beschreibung" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.description }}
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="doku_name">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_OBJECTS.name" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.lastName }}
          </td>
        </ng-container>

        <!-- Settings Menu Column -->
        <ng-container matColumnDef="menuBild">
          <th mat-header-cell *matHeaderCellDef style="text-align: center"></th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            <button mat-icon-button [matMenuTriggerFor]="anpaMenu" *ngIf="element.art === 12" aria-label="Example icon-button with a menu">
              <mat-icon>more_horiz</mat-icon>
            </button>
            <button mat-icon-button [matMenuTriggerFor]="objActMenu" *ngIf="element.art !== 12" aria-label="Example icon-button with a menu">
              <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #anpaMenu="matMenu">
              <button mat-menu-item (click)="showImage(element)">
                <mat-icon>photo</mat-icon>
                <span>{{ "MAIN_APP_OBJECTS.anzeigen" | translate }}</span>
              </button>
	            <button mat-menu-item>
                <mat-icon>file_download</mat-icon>
                <span>{{ "MAIN_APP_OBJECTS.download" | translate }}</span>
              </button>
              <button mat-menu-item (click)="editImage(element)">
                <mat-icon>brush</mat-icon>
                <span>{{ "MAIN_APP_OBJECTS.bearbeiten" | translate }}</span>
              </button>
              <button mat-menu-item (click)="delImage(element)">
                <mat-icon>delete_forever</mat-icon>
                <span>{{ "MAIN_APP_OBJECTS.löschen" | translate }}</span>
              </button>
            </mat-menu>
            <mat-menu #objActMenu="matMenu">
              <button mat-menu-item (click)="delActivity(element)">
                <mat-icon>delete_forever</mat-icon>
                <span>{{ "MAIN_APP_OBJECTS.löschen" | translate }}</span>
              </button>
              <button *ngIf="[1,16].includes(element.art)" mat-menu-item (click)="downloadDocument(element)">
                <mat-icon>file_download</mat-icon>
                <span>{{ "MAIN_APP_OBJECTS.download" | translate }}</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedObjDokuColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedObjDokuColumns" [ngClass]="{ highlight: selectedObjektDocumentID == row.ID }"></tr>
      </table>
    </main>
  </ng-container>

  <ng-container *ngIf="toggle === 'objektansicht'">
    <main class="mobile objects view">
      <div class="objektadresse">
        <img src="../../../../assets/hauptapp_mobile/Kunde.png" alt="user" />
        <div class="objektadresse_details">
          <p>
            <b>{{ currObjekt.description }}</b>
          </p>
        </div>
        <button mat-button routerLink="/adressen-mobile">
          <div>
            <img src="../../../../assets/hauptapp_mobile/Lupe.png" alt="search" />
          </div>
        </button>
      </div>

      <mat-divider></mat-divider>

      <div>
        <div class="object_result"> {{ "MAIN_APP_OBJECTS.bemerkung" | translate }} 1: <a href="tel:{{ currObjekt.note1 }}">{{ currObjekt.note1 }}</a> </div>
        <mat-divider></mat-divider>
        <div class="object_result"> {{ "MAIN_APP_OBJECTS.bemerkung" | translate }} 2: <a href="tel:{{ currObjekt.note2 }}">{{ currObjekt.note2 }}</a> </div>
        <mat-divider></mat-divider>
        <div class="object_result"> {{ "MAIN_APP_OBJECTS.bemerkung" | translate }} 3: <a href="tel:{{ currObjekt.note3 }}">{{ currObjekt.note3 }}</a> </div>
        <mat-divider></mat-divider>
        <div class="object_result"> {{ "MAIN_APP_OBJECTS.status" | translate }}: <a href="mailto:{{ currObjekt.status }}">{{ currObjekt.status }}</a> </div>
        <mat-divider></mat-divider>
        <div class="object_result"> ProdStart: <a href="mailto:{{ currObjekt.prodStart }}">{{ currObjekt.prodStart }}</a> </div>
        <mat-divider></mat-divider>
      </div>
    </main>
  </ng-container>

  <ng-container *ngIf="toggle === 'teilen'">
    <main class="mobile objects share">
      <div class="objektadresse">
        <img src="../../../../assets/hauptapp_mobile/Kunde.png" alt="user" />
        <div class="objektadresse_details">
          <h4>
            <b> {{ currObjekt.description }} </b>
          </h4>
        </div>
        <button mat-button routerLink="#">
          <div>
            <img src="../../../../assets/hauptapp_mobile/Lupe.png" alt="search" />
          </div>
        </button>
      </div>

      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ "MAIN_APP_OBJECTS.note1" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <a href="tel:{{ currObjekt.note1 }}">{{ currObjekt.note1 }}</a>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ "MAIN_APP_OBJECTS.note1" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <a href="tel:{{ currObjekt.note2 }}">{{ currObjekt.note2 }}</a>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </main>
  </ng-container>


  <footer class="mobile objects">
    <mat-icon class="icon-size" (click)="onNewObjekt()">add</mat-icon>
    <mat-icon class="icon-size" (click)="toggleBtn('suchen')" *ngIf="toggle !== 'suchen'" [ngClass]="{'highlight': toggle == 'suchen' }">search</mat-icon>
    <mat-icon class="icon-size" (click)="toggleBtn('baum')" *ngIf="toggle !== 'baum'" [ngClass]="{'highlight': toggle == 'baum' }">account_tree</mat-icon>
    <mat-icon class="icon-size" (click)="toggleBtn('mutieren')" *ngIf="toggle !== 'mutieren'">change_history</mat-icon>
    <mat-icon class="icon-size" (click)="toggleBtn('objektansicht')" *ngIf="toggle !== 'objektansicht'">data_object</mat-icon>
    <mat-icon class="icon-size" (click)="toggleBtn('teilen')" *ngIf="toggle !== 'teilen'">info</mat-icon>
    <mat-icon class="icon-size" (click)="toggleBtn('adressen')" *ngIf="toggle !== 'adressen'">apartment</mat-icon>
    <mat-icon class="icon-size" (click)="toggleBtn('objekt-aktivitat')" *ngIf="toggle !== 'objekt-aktivitat'">note</mat-icon>
  </footer>
</div>
